import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#e8eaed" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M360-620h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80zm138.46 520H252.31Q222-100 201-121q-21-21-21-51.31v-375.38Q180-578 201-599q21-21 51.31-21H300v-80q0-74.92 52.54-127.46Q405.08-880 480-880q74.92 0 127.46 52.54Q660-774.92 660-700v80h47.69Q738-620 759-599q21 21 21 51.31V-498q-13-4.46-27.89-6.69-14.88-2.23-32.11-2.23v-40.77q0-5.39-3.46-8.85t-8.85-3.46H252.31q-5.39 0-8.85 3.46t-3.46 8.85v375.38q0 5.39 3.46 8.85t8.85 3.46h216.61q5.7 17.85 12.16 31.31 6.46 13.46 17.38 28.69zm213.85 32.31q-74.93 0-127.46-52.54-52.54-52.54-52.54-127.46 0-74.93 52.54-127.46 52.53-52.54 127.46-52.54 74.92 0 127.46 52.54 52.54 52.53 52.54 127.46 0 74.92-52.54 127.46-52.54 52.54-127.46 52.54zm66-89.08l24.92-24.92L730-254.92v-110.47h-35.39v124.93l83.7 83.69zM240-444.61V-160v-400 115.39z"
      ></path>
    </svg>
  );
}

export default Icon;
